//
// WebMapConstraints.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "@sas-dvr/ltjs-commons/models/BaseModel";

var WebMapConstraints = createModule("gtl::WebMapConstraints", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getProjection: [7],
        getMaxScale: [5],
        getExtent: [12],
    },
    {
        _create: [4,7,12,5],
    },
    ,
]);
export default WebMapConstraints;
